import axios from 'axios';
import store from '../store/index';
import router from '../router'

const instance = axios.create({
    //baseURL: process.env.VUE_APP_BASE_URL, 
    //baseURL: 'http://rup.test/api',
    baseURL: 'https://api.rup.antonioluquin.com.ar/api',
});
//instance.defaults.withCredentials = true;
instance.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token')

instance.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            // Código 401: Usuario no autorizado
            store.commit("clearAuth");
            if (router.currentRoute.path !== 'login'
            ) {
                //El usuario no está autenticado, mostramos el mensaje correspondiente
                store.commit('showModalUnauthenticated', true);
            }
        }
        return Promise.reject(error);
    }
);
export default instance;